import { TeamInsuranceProduct } from 'types';
import { CapitolaClient } from './base';

export default class TeamInsuranceProductClient extends CapitolaClient<TeamInsuranceProduct> {
  public get resourceName(): string {
    return 'team-insurance-product';
  }
}
